<template>
  <div>
    <v-divider v-if="$vuetify.display.mdAndUp || index > 0"/>
    <v-list-item :to="{ name: 'accountant-client-view', params: { id: id }}" :replace="true" class="px-0">
      <v-row justify="center">
        <v-col cols="12" md="3" class="text-md-center pl-md-5" align-self="center">
          <p v-if="$vuetify.display.smAndDown" class="text-caption">Username</p>
          <p class="text-md-subtitle-1 text-h6  text-md-center">{{ username }}</p>
        </v-col>
        <v-col cols="12" md="4" class="text-md-center pl-md-5" align-self="center">
          <p v-if="$vuetify.display.smAndDown" class="text-caption">Client name</p>
          <p class="text-md-subtitle-1 text-h6  text-md-center">{{ name }}</p>
        </v-col>
        <v-col md="5" class="text-md-center pl-md-5" align-self="center">
          <p v-if="$vuetify.display.smAndDown" class="text-caption">Balances</p>
          <p class="text-md-subtitle-1 text-h6 text-md-center">
            <span v-for="(balance, index) in balances" :key="index">
              {{ balance }}
              <span v-if="index !== balances.length - 1">{{ '/' }}</span>
            </span>
          </p>
        </v-col>
      </v-row>
    </v-list-item>
  </div>
</template>

<script>

export default{
  name: "AccountantListItem",
  props: {
    id: String,
    username: String,
    name: String,
    balances: Array,
    index: Number,
  }
}
</script>

<style scoped>

</style>